/**
 * Task Priority Badge Component
 */

import { cn } from '@/lib/utils';
import { ArrowDown, ArrowRight, ArrowUp, AlertTriangle } from 'lucide-react';
import type { TaskPriority } from '../types';

const PRIORITY_CONFIG: Record<
  TaskPriority,
  {
    label: string;
    icon: React.ElementType;
    className: string;
  }
> = {
  low: {
    label: 'Low',
    icon: ArrowDown,
    className: 'text-muted-foreground',
  },
  medium: {
    label: 'Medium',
    icon: ArrowRight,
    className: 'text-yellow-600 dark:text-yellow-500',
  },
  high: {
    label: 'High',
    icon: ArrowUp,
    className: 'text-orange-600 dark:text-orange-500',
  },
  urgent: {
    label: 'Urgent',
    icon: AlertTriangle,
    className: 'text-red-600 dark:text-red-500',
  },
};

interface TaskPriorityBadgeProps {
  priority: TaskPriority;
  showLabel?: boolean;
  className?: string;
}

export function TaskPriorityBadge({
  priority,
  showLabel = false,
  className,
}: TaskPriorityBadgeProps) {
  const config = PRIORITY_CONFIG[priority] || {
    label: priority,
    icon: ArrowRight,
    className: 'text-muted-foreground',
  };
  const Icon = config.icon;

  return (
    <div className={cn('flex items-center gap-1', config.className, className)}>
      <Icon className="h-4 w-4" />
      {showLabel && <span className="text-xs font-medium">{config.label}</span>}
    </div>
  );
}
